import {DocJournalPieChart} from 'components/widget/items/documents-publication-pie-chart';
import {News} from 'components/widget/items/news';
import {NobComponentsBarChart} from 'components/widget/items/nob-components-bar-chart';
import {RequestTable} from 'components/widget/items/request-table';

export const WIDGET_HALF_PADDING = 4;

export enum EWidgetPageComponents {
    NEWS = 'NEWS',
    REQUEST_TABLE = 'REQUEST_TABLE',
    DOC_JOURNAL_PIE_CHART = 'DOC_JOURNAL_PIE_CHART',
    NOB_COMPONENTS_BAR_CHART = 'NOB_COMPONENTS_BAR_CHART',
}

export const widgetDraggableComponentsInitialState: IWidgetComponentProps[][] = [
    [
        {component: EWidgetPageComponents.REQUEST_TABLE, entityName: 'widgets.requests'},
        {component: EWidgetPageComponents.NOB_COMPONENTS_BAR_CHART},
    ],
    [
        {component: EWidgetPageComponents.DOC_JOURNAL_PIE_CHART},
        {component: EWidgetPageComponents.NEWS},
    ],
];

export const widgetPageComponentMap = {
    [EWidgetPageComponents.REQUEST_TABLE]: RequestTable,
    [EWidgetPageComponents.DOC_JOURNAL_PIE_CHART]: DocJournalPieChart,
    [EWidgetPageComponents.NEWS]: News,
    [EWidgetPageComponents.NOB_COMPONENTS_BAR_CHART]: NobComponentsBarChart,
};

export interface IWidgetComponentProps {
    component: EWidgetPageComponents;
    entityName?: string;
}

export const getNumberOfWidgetColumns = (widgets: IWidgetComponentProps[][]) => widgets.reduce(
    (acc, curr) => (curr.length ? acc + 1 : acc),
    0,
);

export const getNumberOfMaxWidgetsPerColumn = (widgets: IWidgetComponentProps[][]) => widgets.reduce(
    (acc, curr) => (curr.length > acc ? curr.length : acc),
    0,
);

export const checkIfAllColumnsHaveOneWidget = (widgets: IWidgetComponentProps[][]) => widgets.reduce(
    (acc, curr) => (curr.length === 1 ? acc : false),
    true,
);
